export default __webpack_public_path__ + "static/media/what-we-offer-bottom-bg.9259957d.png";